
export enum EnumIdsTcEstadoSolicitudCpe {
    ID_BORRADOR = 1,
    ID_NUEVA = 2,
    ID_CONFORME = 3,
    ID_NO_CONFORME = 4,
    ID_EN_TRAMITE = 5,
    ID_ANULADA = 6,
    ID_REVISION_SOLICITANTE = 7
}


